// extracted by mini-css-extract-plugin
export default {"wrapper":"CommonButton_wrapper__pjeav"};